export const saddhaData = {
    my: {
        title: "သဒ္ဓါဝဍ္ဎနတန်း",
        subtitle: "သဒ္ဓါတရားကို တိုးပွားစေတတ်သောအတန်း",
        subjects: [
            {
                name: "ရုပ်ပုံရှင်ကျင့်ဝတ်",
                description: "သာသနာဘောင်သို့ ရောက်ခါစ ရှင်သာမဏေအသစ်များ မည်သို့ နေရထိုင်ရမည်ကို တတ်သိနားလည်ပြီး လိုက်နာကျင့်သုံးတတ်ရန် ဖြစ်၏။"
            },
            {
                name: "ရတနာ့ဂုဏ်ရည်",
                description: "သာသနာ၏ အနှစ်သာရကို ငယ်ရွယ်စဉ်ကပင် နားလည်ထားစေရန်နှင့် မြန်မာစာပေ လေ့လာမှုအတွက်ပါ အထောက်အကူဖြစ်စေရန်"
            },
            {
                name: "သဒ္ဒါ (သန္ဓိပိုင်း)",
                description: "အထက်အတန်းတွေ၌သာ စာတွေများပြီး ဝန်ပိမနေစေရန်နှင့် ထိုက်သင့်သော စာအခြေခံလေး ကြိုတင်ရနေစေရန်"
            }
        ],
        examNote: "သဒ္ဓါဝဍ္ဎနတန်း ၌ တစ်ဘာသာလျှင် ၆-ပုစ္ဆာ မေးရမည်။ အာဂုံအောင်မှတ် ၁၀-မှတ်နှင့်တကွ အောင်မှတ်မှာ ၂၄-မှတ် ဖြစ်သည်။ ၅၀-မှတ်သည် ဂုဏ်ထူးမှတ်၊ ၅၄-မှတ်သည် ဝိသိဋ္ဌဂုဏ်ထူးမှတ် ဖြစ်သည်။",
        conclusion: "ထို့ကြောင့် ဤအတန်းသည် စာသင်တိုက်သို့ ရောက်ခါစ စာသင်သားများအတွက် ရည်ရွယ်ပါသည်။"
    },
    en: {
        title: "Saddhāvaḍḍhana",
        subtitle: "The Grade that Increases Faith",
        subjects: [
            {
                name: "Monastic Etiquette",
                description: "Designed for new novices to understand and practice proper monastic conduct and daily routines."
            },
            {
                name: "Noble Qualities",
                description: "To understand the essence of Buddhism from an early age and support Myanmar literature studies."
            },
            {
                name: "Grammar (Sandhi)",
                description: "Basic grammar foundations to prepare for advanced studies and reduce workload in higher grades."
            }
        ],
        examNote: "Each subject consists of 6 questions. Passing mark is 24 including 10 marks for memorization. 50 marks earn distinction, and 54 marks earn high distinction.",
        conclusion: "This grade is specifically designed for newcomers to the monastery."
    }
};